export default __webpack_public_path__ + "static/media/illustration4-min.be135401.webp";